import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login';
import VerificationPage from './pages/VerificationPage';
import DashboardPage from './pages/Dashboard';
import ConcursosPage from './pages/Concursos';
import ClientesPage from './pages/Clientes';
import ClientePage from './pages/Cliente';
import AdjudicacionesPage from './pages/Adjudicaciones';
import UsuariosPage from './pages/Usuarios';
import FavoritosPage from './pages/Favoritos';
import SoporteTecnicoPage from './pages/SoporteTecnico';
import SoporteAdministrativoPage from './pages/SoporteAdministrativo';
import SoporteJuridicoPage from './pages/SoporteJuridico';
import LayoutWithSidebar from './layouts/sidebar';
import { useAuth } from './security/AuthLogin';
import FullScreenSpinner from './components/FullScreenSpinner';
import ConcursoPage from './pages/Concurso';
import CreateConcursoPage from './pages/CrearConcurso';
import AdjudicacionPage from './pages/Adjudicacion';
import FavoritoPage from './pages/Favorito';
import BajaEstadisticaPage from './pages/BajaEstadistica';
import BajasEstadisticasPage from './pages/BajasEstadisticas';
import SoportesTecnicosPage from './pages/SoportesTecnicos';
import SoportesAdministrativosPage from './pages/SoportesAdministrativos';
import SoportesJuridicosPage from './pages/SoportesJuridicos';
import DiccionarioCpvsPage from './pages/DiccionarioCpvs';


function AppRouter() {
  const { isAuthenticated, userRole, isLoading } = useAuth();

  // Muestra el spinner mientras se verifica la autenticación
  if (isLoading) {
    return <FullScreenSpinner />;
  }

  return (
    <Routes>
      {/* Ruta de LoginPage solo si no está autenticado */}
      <Route
        path="/login"
        element={
          !isAuthenticated ? <LoginPage /> : <Navigate to="/verification" />
        }
      />

      {/* Ruta de Verificación después de login */}
      <Route
        path="/verification"
        element={
          isAuthenticated ? <VerificationPage /> : <Navigate to="/login" />
        }
      />

      {/* Rutas protegidas */}
      {isAuthenticated ? (
        <Route path="/" element={<LayoutWithSidebar />}>
          {/* Ruta principal al Dashboard */}
          <Route
            index
            element={<DashboardPage role={userRole || "cliente"} />}
          />

          {/* Rutas específicas del rol admin */}
          {userRole === "admin" && (
            <>
              <Route path="concursos/crear" element={<CreateConcursoPage />} />
              <Route path="clientes" element={<ClientesPage />} />
              <Route path="cliente/:id_usuario" element={<ClientePage />} />
              <Route path="usuarios" element={<UsuariosPage />} />
              <Route
                path="/diccionario-cpvs"
                element={<DiccionarioCpvsPage />}
              />
            </>
          )}

          {userRole === "tecnico" && (
            <>
              <Route path="concursos/crear" element={<CreateConcursoPage />} />
              <Route path="clientes" element={<ClientesPage />} />
              <Route path="cliente/:id_usuario" element={<ClientePage />} />
              <Route
                path="/diccionario-cpvs"
                element={<DiccionarioCpvsPage />}
              />
            </>
          )}

          {/* Ruta específica para el detalle del concurso */}
          <Route path="concurso/:id" element={<ConcursoPage />} />
          <Route path="adjudicacion/:id" element={<AdjudicacionPage />} />

          {/* Rutas comunes a todos los roles */}
          <Route path="concursos" element={<ConcursosPage />} />
          <Route path="favoritos" element={<FavoritosPage />} />
          <Route path="soportes-tecnicos" element={<SoportesTecnicosPage />} />
          <Route
            path="soporte-tecnico/:id_concurso/:id_usuario"
            element={<SoporteTecnicoPage />}
          />
          <Route
            path="soporte-administrativo/:id_concurso/:id_usuario"
            element={<SoporteAdministrativoPage />}
          />
          <Route
            path="soporte-juridico/:id_concurso/:id_usuario"
            element={<SoporteJuridicoPage />}
          />
          <Route
            path="/favorito/:id_concurso/:id_usuario"
            element={<FavoritoPage />}
          />
          <Route
            path="/baja-estadistica/:id_concurso/:id_usuario"
            element={<BajaEstadisticaPage />}
          />
          <Route
            path="/bajas-estadisticas/"
            element={<BajasEstadisticasPage />}
          />
          <Route
            path="/soportes-administrativos/"
            element={<SoportesAdministrativosPage />}
          />
          <Route
            path="/soportes-juridicos/"
            element={<SoportesJuridicosPage />}
          />
          <Route path="adjudicaciones" element={<AdjudicacionesPage />} />

          {/* Ruta por defecto para cualquier otra página */}
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
    </Routes>
  );
}

export default AppRouter;
